import * as React from 'react';
import { sortBy } from 'lodash';
import { connect } from 'react-redux';

import ContentGallery from 'components/content-gallery/ContentGallery';
import ClientApprovalEntrySubtitle from '../client-approval-entry-subtitle/ClientApprovalEntrySubtitle';
import ClientApprovalEntryGalleryFooter from '../client-approval-entry-gallery-helper/ClientApprovalEntryGalleryFooter';
import ClientApprovalEntryGalleryOverlay from '../client-approval-entry-gallery-helper/ClientApprovalEntryGalleryOverlay';
import ClientApprovalEntryGalleryThumbnailOverlay from '../client-approval-entry-gallery-helper/ClientApprovalEntryGalleryThumbnailOverlay';

import ClientApprovalGalleryContext from '../../context/ClientApprovalGalleryContext';

import { __t, applyTranslations } from 'utils/language';

import type { ClientApprovalBucketV2, ClientApprovalStatus } from 'types';

applyTranslations(require('./client-approval-entry-content.i18n.json'));

type OwnProps = {
  item: ClientApprovalBucketV2,
  onAssetApprovalChange: (itemId: number, status: ClientApprovalStatus) => void
};

type StateProps = {
  markAsFavLoadingAsset: {
    [itemId: number]: boolean
  }
}

type Props = OwnProps & StateProps;

const ClientApprovalEntryContent = ({ item, markAsFavLoadingAsset, onAssetApprovalChange }: Props): JSX.Element => {
  const mappedAttachments = sortBy(
    item.items.map(entry => ({
      ...entry,
      assetType: entry.mediaType,
      bucketId: item.id,
      isMarkAsFavLoading: markAsFavLoadingAsset[entry.id]
    })),
    'id'
  );

  const contextData = {
    look: item.look,
    onAssetApprovalChange
  };

  return (
    <React.Fragment>
      <ClientApprovalEntrySubtitle>
        {__t('client_approval_entry_content.title')}
      </ClientApprovalEntrySubtitle>

      <ClientApprovalGalleryContext.Provider value={contextData}>
        <ContentGallery
          items={mappedAttachments}
          itemSize="size-180"
          renderTriggerFooter={ClientApprovalEntryGalleryFooter}
          renderGalleryAssetOverlay={ClientApprovalEntryGalleryOverlay}
          renderGalleryThumbnailOverlay={ClientApprovalEntryGalleryThumbnailOverlay}
        />
      </ClientApprovalGalleryContext.Provider>
    </React.Fragment>
  );
};

const mapStateToProps = ({ clientApprovalV2 }): StateProps => ({
  markAsFavLoadingAsset: clientApprovalV2.markAsFavLoadingAsset
});

export default connect(mapStateToProps, null)(ClientApprovalEntryContent);
